import { createServerFn } from "@tanstack/react-start"
import { Result } from "@praha/byethrow"
import { getMyEvents as getMyEventsService, toggleAttend as toggleAttendService } from "@apps/gwservice/events"
import { withAuth } from "~/features/auth/server/auth"

export const getMyEvents = createServerFn({
  method: "GET",
}).handler(() => Result.try({
  try: () => withAuth(getMyEventsService)(false),
  catch: () => "unexpected server error",
}))

export const toggleAttend = createServerFn({
  method: "POST",
})
  .inputValidator((data: { eventId: number }) => data)
  .handler(({ data }) => Result.try({
    try: () => withAuth(toggleAttendService)(data.eventId),
    catch: () => "unexpected server error",
  }))
